const STOCK_DECIMALS = 2;
const STOCK_FACTOR = 10 ** STOCK_DECIMALS;

export function roundIngredientStock(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * STOCK_FACTOR) / STOCK_FACTOR;
}

export function parseIngredientStock(raw: string): number {
  const trimmed = raw.trim();
  if (!trimmed) return 0;

  const normalized =
    trimmed.includes(',') && trimmed.includes('.')
      ? trimmed.replace(/,/g, '')
      : trimmed.includes(',')
        ? trimmed.replace(',', '.')
        : trimmed;

  return roundIngredientStock(Number(normalized));
}
